import * as React from 'react';

import { TaskRecoveryContext } from 'af-root/context/taskRecoveryContext';

export const useTaskRecovery = () => React.useContext(TaskRecoveryContext);
